<template>
    <div>
        <div id="tips" @click="stopMark" v-if="getTips" v-cloak>
            <div class="notOpen">
                <!--<img src="@/assets/index/tipsImg.png" alt="">-->
                <span>{{getTipsTxt}}</span></div>
        </div>
        <div v-if="loading" v-cloak>
            <div class="notOpen">
                <!--<img class="loading imgRotate" src="@/assets/index/loading.png" alt="">-->
	            <i class="tz-icon tz_loading imgRotate"></i>
                <span>数据加载中...</span></div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                timer: false
            }
        },
        computed: {
            getTips() {
                this.delayStopMark();
                return this.$store.state.tips
            },
            getTipsTxt() {
                return this.$store.state.tipsTxt
            },
            loading() {
                return this.$store.state.loading
            }
        },
        methods: {
            stopMark() {
                this.$store.commit({
                    type: "setTips",
                    tips: false,
                    tipsTxt: ''
                })
            },
            delayStopMark() {
                var that = this;
                this.timer = setTimeout(function () {
                    clearTimeout(that.timer);
                    that.stopMark();
                }, 3000)
            },
            showTips(str) {
                this.$public.tips(str)
            }
        },
        mounted() {
            window.showTips = this.showTips
        }
    }
</script>
<style scoped>
    #tips {
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 15;
    }

    .notOpen {
        width: 600px;
        height: 80px;
        color: #fff;
        font-size: 20px;
        font-family: 'kt';
        display: flex;
        align-items: center;
        justify-content: center;
        background-image: linear-gradient(to right, rgba(18, 25, 52, 0), rgba(18, 25, 52, .9), rgba(18, 25, 52, 0));
        position: absolute;
        left: 50%;
        top: 50%;
        margin-left: -300px;
        margin-top: -40px;
        z-index: 16;
    }

    .notOpen img {
        width: 60px;
        margin-right: 20px;
    }

    @media (max-width: 1110px) {
        .notOpen {
            width: 300px;
            height: 40px;
            color: #fff;
            font-size: 1.6rem;
            font-family: 'kt';
            display: flex;
            align-items: center;
            justify-content: center;
            background-image: linear-gradient(to right, rgba(18, 25, 52, 0), rgba(18, 25, 52, .9), rgba(18, 25, 52, 0));
            position: absolute;
            left: 50%;
            top: 50%;
            margin-left: -150px;
            margin-top: -20px;
            z-index: 16;
        }

        .notOpen img {
            width: 30px;
            margin-right: 10px;
        }

        .loading {
            width: 20px !important;
            margin-left: 0;
        }
    }

    @media (max-height: 450px) {
        .notOpen {
            width: 300px;
            height: 40px;
            font-size: 1.4rem;
            margin-left: -150px;
            margin-top: -20px;
        }

        .notOpen img {
            width: 30px;
            margin-right: 10px;
        }

        .loading {
            width: 20px !important;
        }
    }
	.tz_loading{
		margin-right: 10px;
	}
</style>



// WEBPACK FOOTER //
// src/components/tips/tips.vue